/**
 *  Attributes
 * 
 	data-toggle					// Goes on toggle element				(required: The value should match: "data-toggle-id") 
	data-toggle-id				// Goes on target element				(required: The value should match: "data-toggle")
	data-toggle-group 			// Goes on target element				(optional)
	data-toggle-auto-focus		// Goes on toggle element 				(optional)
	data-toggle-class      		// Goes on toggle and target element 	(optional)
	data-toggle-auto-height		// Goes on target element				(optional)
 */
const toggles = {
    _attrs: {
        toggle: 'data-toggle',
        target: 'data-toggle-id',
        group: 'data-toggle-group',
        focus: 'data-toggle-auto-focus',
		cssClass: 'data-toggle-class',
		autoHeight: 'data-toggle-auto-height'
    },
	_groups: {},
    _toggles: [],
    _currents: {},

    init() {
        let toggles = document.querySelectorAll(`[${this._attrs.toggle}]`);

        if (!toggles) {
            return;
        }

		let index = 0;

        for (index = 0; index < toggles.length; index++) {
	        if( this._toggles.indexOf(toggles[index]) === -1 ){
	            toggles[index].addEventListener('click', this._handleToggle.bind(this, toggles[index]));
		        this._toggles.push(toggles[index]);
            }
		}
		
		let autoHeightTargets = document.querySelectorAll(`[${this._attrs.autoHeight}]`);

		if (!autoHeightTargets.length) {
			return;
		}

		for (index = 0; index < autoHeightTargets.length; index++) {
	        autoHeightTargets[index].style.maxHeight = '0px';
		}
    },

	change(){
		if( Object.keys(this._currents).length ){
			for( let id in this._currents ){
				this._handleToggle(this._currents[id].toggle);
			}
		}
	},

    reload(){
        this.init();
    },

    isGroupActive(groupId){
        return Boolean(this._groups[groupId] && Boolean(this._groups[groupId].current.id));
    },

    isGroupToggleActive(groupId, toggleId){
        if( !this.isGroupActive(groupId) ){
            return false;
        }

        return this._groups[groupId].current.id === String(toggleId);
    },

    deactivateGroup(groupId){
	    if( this.isGroupActive(groupId) ){
		    this._handleToggle(this._groups[groupId].current.toggle);
	    }

	    return true;
    },

    _handleToggle(toggle, event) {
        if( event ){
	        event.preventDefault();
        	event.stopPropagation();
        }

	    let object    = {};
	    object.id     = toggle.getAttribute(this._attrs.toggle);
	    object.toggle = toggle;
	    object.target = document.querySelector(`[${this._attrs.target}="${object.id}"]`);

        if( !object.target ){
            return;
        }

		object.toggleClass = object.toggle.getAttribute(this._attrs.cssClass) || "active";
		object.targetClass = object.target.getAttribute(this._attrs.cssClass) || "active";
		object.bodyClass   = `toggle-${object.id}--active`;

	    let group = object.target.hasAttribute(this._attrs.group) ? object.target.getAttribute(this._attrs.group) : null;
		let focus = object.toggle.hasAttribute(this._attrs.focus); 

        if (group) {
            group = this._groups[group] || {
                id: group,
                current: {
                    id: null,
	                toggle: null,
	                target: null,
                }
            };

	        if( object.id === group.current.id ){
		        group.current = {
			        id: null,
			        toggle: null,
			        target: null
		        };
	        }
	        else {
	        	if( group.current.id ){
			        let groupCurrentClasses = {
				        toggle: group.current.toggle.getAttribute(this._attrs.cssClass) || 'active',
				        target: group.current.target.getAttribute(this._attrs.cssClass) || 'active',
			        };

			        group.current.toggle.classList.remove(groupCurrentClasses.toggle);
					group.current.target.classList.remove(groupCurrentClasses.target);

					if(this._hasAutoHeight(group.current.target)){
						group.current.target.style.maxHeight = '0px';
					}

			        delete this._currents[group.current.id];
		        }

		        group.current = object;
			}

	        object.bodyClass = `toggle-${group.id}--active`;
	        this._groups[group.id] = group;
        }


	    if( this._currents[object.id] ){
		    delete this._currents[object.id];
	    }
	    else{
		    this._currents[object.id] = object;
		}

		if( this._hasAutoHeight(object.target) ){
			this._autoHeight(object);
		}

        document.body.classList.toggle(object.bodyClass);
        object.target.classList.toggle(object.targetClass);
        object.toggle.classList.toggle(object.toggleClass);

	    if (focus) {
		    let input = object.target.querySelector('input');
		    if (input) {
			    input.focus();
		    }
	    }
	},

	_autoHeight(object){
		if( !object.target.style.maxHeight ){
			object.target.style.maxHeight = '0px';
		}

		let maxHeight = 0;

		if( object.target.style.maxHeight === '0px' ){
			maxHeight = this._calcMaxHeight(object.target);
		}

		object.target.style.maxHeight = `${maxHeight}px`;
	},
	
	_calcMaxHeight(element){
        let clone     = element.cloneNode(true);
        let container = (element.parentNode || document.body);
        
		clone.style.maxHeight  = 'initial';
		clone.style.transition = 'initial';
        clone.style.animation  = 'initial';

        clone = container.appendChild(clone);
        let autoHeight = clone.getBoundingClientRect().height;
		container.removeChild(clone);

		return autoHeight;
	},

	_hasAutoHeight(element){
		return JSON.parse(element.getAttribute(this._attrs.autoHeight))
	}
};

toggles.init();